import React, { useEffect, useState, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2 } from 'lucide-react';
import memberApi from '../../lib/memberApi';
import { AuthLayout } from '../../components/member/AuthLayout';

export default function MemberVerify() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) {
      setStatus('error');
      setMessage('Geçersiz doğrulama bağlantısı.');
      return;
    }
    memberApi
      .get(`/members/auth/verify?token=${encodeURIComponent(token)}`)
      .then((res) => {
        setStatus('success');
        setMessage(res.data.message);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.detail || 'Doğrulama başarısız.');
      });
  }, [token]);

  return (
    <AuthLayout title="E-posta Doğrulama" testid="member-verify-page">
      <div className="text-center space-y-4">
        {status === 'loading' && <Loader2 className="w-12 h-12 text-[hsl(var(--gold))] mx-auto animate-spin" />}
        {status === 'success' && <CheckCircle2 className="w-12 h-12 text-[hsl(var(--gold))] mx-auto" />}
        {status === 'error' && <XCircle className="w-12 h-12 text-destructive mx-auto" />}
        <p className="text-sm text-muted-foreground" data-testid="member-verify-message">{message || 'Doğrulanıyor...'}</p>
        {status !== 'loading' && (
          <Link to="/uye/giris" className="inline-block text-sm text-[hsl(var(--gold))] font-medium hover:underline">Giriş sayfasına git</Link>
        )}
      </div>
    </AuthLayout>
  );
}
